import { transparentize } from 'polished'
import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.div`
	width: 100%;
	border-radius: ${helpers.borderRadius};
	background-color: ${({ theme }) => transparentize(0.91, theme.color.action)};
	margin: ${helpers.spacing.medium} 0 ${helpers.spacing.xLarge};
`
